import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    // Show loading state while checking auth
    return (
      <div className="min-h-screen bg-[#fbf1c7] text-[#3c3836] font-mono flex items-center justify-center">
        <div className="text-center">
          <div className="text-2xl mb-4 font-bold text-[#af3a03]">[ AUTHENTICATING... ]</div>
          <div className="animate-pulse text-[#d65d0e]">████████████████</div>
        </div>
      </div>
    );
  }

  if (!user) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;

